import type { TFunction } from "i18next";

type QuestionsNavConfig = {
	handleOpenSessionItemsNav: () => void;
	questionsNavActiveFilterCount?: number;
};

export const buildQuestionsConfig = (
	sessionItemsNav: QuestionsNavConfig | null | undefined,
	isSummativeTest: boolean | undefined,
	t: TFunction,
) => {
	if (!(sessionItemsNav && isSummativeTest)) {
		return undefined;
	}
	const filterCount = sessionItemsNav.questionsNavActiveFilterCount ?? 0;
	return {
		onPress: sessionItemsNav.handleOpenSessionItemsNav,
		activeFilterCount: filterCount,
		label: t("session.navigation.questionsButtonLabel"),
		a11yLabel:
			filterCount > 0
				? t("session.navigation.questionsButtonActiveFiltersA11y", {
						count: filterCount,
					})
				: undefined,
		tooltip: t("session.navigation.questionsButtonTooltip"),
	};
};

type ButtonStateArgs = {
	showButtonNavFinish?: boolean;
	showButtonNavSkip?: boolean;
	streaming?: boolean;
};

export const getNextButtonState = ({
	showButtonNavFinish,
	showButtonNavSkip,
	streaming,
}: ButtonStateArgs): "finish" | "skip" | "next" => {
	if (showButtonNavFinish) {
		return "finish";
	}
	if (showButtonNavSkip && !streaming) {
		return "skip";
	}
	return "next";
};

type ButtonConfigArgs = {
	streaming?: boolean;
	nextButtonText: string;
	prevButtonText: string;
	disableNextButton: boolean;
	nextButtonTooltip?: { next?: string };
	isRecordingActive?: boolean;
	recordingActiveTooltip?: string;
	inReviewMode?: boolean;
	t: TFunction;
};

export const buildButtonConfig = ({
	streaming,
	nextButtonText,
	prevButtonText,
	disableNextButton,
	nextButtonTooltip,
	isRecordingActive,
	recordingActiveTooltip,
	inReviewMode,
	t,
}: ButtonConfigArgs) => ({
	texts: {
		next: streaming ? t("session.navigation.next") : nextButtonText,
		previous: prevButtonText,
		skip: t("session.navigation.skip"),
		finish: t("session.navigation.finish"),
		help: t("session.navigation.help"),
	},
	disabled: {
		next: disableNextButton || streaming,
		previous: !inReviewMode && (streaming || isRecordingActive),
	},
	tooltip: {
		next: nextButtonTooltip?.next,
		previous: recordingActiveTooltip,
	},
});
